import type { EnvironmentService } from '@application/EnvironmentService/EnvironmentService';
import type { FeatureFlag } from '@application/FeatureFlag';
import { allFeatureFlags } from '@application/FeatureFlag';
import {
  ConfigCatFeatureFlagsService,
  FakeFeatureFlagsService,
  LocalStorageFeatureFlagsService,
} from '@inato/browser-feature-flags';

export const buildFeatureFlagsService = (
  environmentService: EnvironmentService,
) => {
  const isServer = typeof window === 'undefined';
  if (isServer) {
    // Browser feature flags services are only meant to run on the client side
    return new FakeFeatureFlagsService<FeatureFlag>([]);
  }

  const configCatApiKey = environmentService.getPossiblyUndefined(
    'PUBLIC_CONFIGCAT_API_KEY',
  );
  return configCatApiKey
    ? new ConfigCatFeatureFlagsService<FeatureFlag>({
        apiKey: configCatApiKey,
      })
    : new LocalStorageFeatureFlagsService<FeatureFlag>(
        localStorage,
        location,
        allFeatureFlags,
      );
};
